import enUS from './en-US'
import koKR from './ko-KR'
import jaJP from './ja-JP'

const lang: { [key: string]: any } = {
	kr: koKR,
	en: enUS,
	jp: jaJP,
}

export default lang
